import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { darkColors, lightColors, spacing, radius, typography, shadows } from '../theme';

const ThemeContext = createContext(null);

const THEME_KEY = '@slate_theme_mode'; // 'dark' | 'light'

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(true); // default dark until pref loads

  useEffect(() => {
    AsyncStorage.getItem(THEME_KEY).then((val) => {
      if (val === 'light') setDark(false);
      else if (val === 'dark') setDark(true);
      // null = never set, keep default dark
    }).catch(() => {});
  }, []);

  function toggleTheme() {
    setDark((prev) => {
      const next = !prev;
      AsyncStorage.setItem(THEME_KEY, next ? 'dark' : 'light').catch(() => {});
      return next;
    });
  }

  const colors = dark ? darkColors : lightColors;

  const value = useMemo(() => ({
    colors,
    spacing,
    radius,
    typography,
    shadows,
    isDark: dark,
    toggleTheme,
  }), [colors, dark]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useAppTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useAppTheme must be used inside ThemeProvider');
  return ctx;
}
